import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { UsuarioVistaModulo } from '@/core/odata/interfaces/MtPerseveranceBackendApiRepositoriesModel'

interface UserState {
  usuarioId: number
  nombreUsuario: string
  isNecessaryUpdateConfiguration: boolean
  configuracion: {
    tieneUsuarioCourier?: boolean
    paginationBookingDetail?: { take: number }
    dataToUpdate?: UsuarioVistaModulo
  }
}

const initialState: UserState = {
  usuarioId: 0,
  nombreUsuario: '',
  isNecessaryUpdateConfiguration: false,
  configuracion: {
    tieneUsuarioCourier: false,
    paginationBookingDetail: { take: 10 },
  },
}

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (
      state,
      action: PayloadAction<{
        usuarioId: number
        nombreUsuario: string
        configuracion: {
          tieneUsuarioCourier?: boolean
          paginationBookingDetail?: { take: number }
        }
      }>,
    ) => {
      state.usuarioId = action.payload.usuarioId
      state.nombreUsuario = action.payload.nombreUsuario
      state.configuracion = action.payload.configuracion
    },
    setIsNecessaryUpdateConfiguration: (
      state,
      action: PayloadAction<{ value: boolean }>,
    ) => {
      state.isNecessaryUpdateConfiguration = action.payload.value
    },
    setPaginationBookingDetail: (
      state,
      action: PayloadAction<{ value: number }>,
    ) => {
      state.configuracion.paginationBookingDetail = {
        take: action.payload.value,
      }
    },
    setDataToUpdate: (
      state,
      action: PayloadAction<{ value: UsuarioVistaModulo }>,
    ) => {
      state.configuracion.dataToUpdate = action.payload.value
    },
  },
})

export const {
  setUser,
  setIsNecessaryUpdateConfiguration,
  setPaginationBookingDetail,
  setDataToUpdate,
} = userSlice.actions

const UserReducer = userSlice.reducer

export default UserReducer
